<div class="condition-item" *ngIf="condition">
    <div class="condition-item-header">
        <div class="title-container">
            <input
                #titleInput
                class="title"
                type="text"
                [(ngModel)]="condition.name"
                (mousedown)="isFocusing ? null : $event.preventDefault()"
                (dblclick)="focusTitle()"
                [maxlength]="NAME_MAX_LEN" />
            <mat-icon
                #optionIcon
                svgIcon="more-options"
                class="icon options-icon"
                [class.selected]="isOpenOption"
                (click)="openOption()"></mat-icon>
        </div>
        <div class="library-component" (click)="openSelectLibraryComponentDialog()">
            {{
                condition?.component?.name
                    ? condition?.component?.name
                    : ('matrix.dialog.condition.component.select' | translate)
            }}
        </div>
        <mat-radio-group class="radio-button-container" [(ngModel)]="condition.operator">
            <mat-radio-button value="AND">{{ 'matrix.dialog.condition.operator.and' | translate }}</mat-radio-button>
            <mat-radio-button value="OR">{{ 'matrix.dialog.condition.operator.or' | translate }}</mat-radio-button>
        </mat-radio-group>
        <div class="more-options-container" [class.show]="isOpenOption">
            <div class="button" (click)="renameCondition(); $event.stopPropagation()">
                {{ 'matrix.dialog.condition.option.rename' | translate }}
            </div>
            <div class="button" (click)="deleteCondition()">
                {{ 'matrix.dialog.condition.option.delete' | translate }}
            </div>
            <div class="button" (click)="clearAllSetting()">
                {{ 'matrix.dialog.condition.option.clear' | translate }}
            </div>
            <div class="button" (click)="setToAlarm()">
                {{ 'matrix.dialog.condition.option.set-alarm' | translate }}
            </div>
        </div>
    </div>
</div>

<div class="condition-item" *ngIf="!condition">
    <div class="condition-item-header">
        <div class="title-container"></div>
        <div class="library-component"></div>
    </div>
</div>
